import React, { useLayoutEffect, useEffect, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import Markers from "wavesurfer.js/src/plugin/markers/index.js";
import { useRecoilState, useSetRecoilState } from "recoil";

import { commands$ } from "./CommandsStream";

import { requestedTrack } from "./atoms";

import { Sequencer } from "./Sequencer";
import { playingTrack } from "./Sequencer";
import { useSequencerReady } from "./Sequencer";

export function Waveform({ id, width = 400, height = 20, markers }) {
  const isReady = useSequencerReady();
  const [currentTrack, setTrack] = useRecoilState(playingTrack);

  const [surfer, setSurfer] = useState();
  const [waveWidth, setWaveWidth] = useState(0);

  const trackLoaded = useSetRecoilState(requestedTrack);

  const to = document.querySelector(`#${id}`);
  if (to && waveWidth === 0) {
    const parent = document.querySelector(`#${id}`);
    const rect = to.getBoundingClientRect();

    if (waveWidth !== rect.width && rect.width !== 0) {
      setWaveWidth(rect.width);
      parent.style.width = `${rect.width}px`;
    }
  }

  useEffect(() => {
    if (!markers || !surfer) return;

    surfer.clearMarkers();

    markers.forEach((marker) => surfer.addMarker(marker));
  }, [markers, surfer]);

  useLayoutEffect(() => {
    if (!surfer) {
      setSurfer(
        WaveSurfer.create({
          container: "#" + id,
          waveColor: "gray",
          progressColor: "#f935ef",
          height: height,
          plugins: [Markers.create({})],
        })
      );
    }

    return () => {
      commands$.stop();
    };
  }, [id, height, width, waveWidth, surfer]);

  useEffect(() => {
    Sequencer.setAudioInstance(surfer);
  }, [isReady, surfer]);

  useLayoutEffect(() => {
    const trackChange = ({ detail: { url, title } }) => {
      trackLoaded(null);

      setTrack({
        url,
        title,
        position: 0,
      });
    };

    const positionChange = ({ detail: { url, title, position } }) => {
      const newPosition = Math.round(position);

      if (newPosition !== currentTrack.position) {
        setTrack({
          url,
          title,
          position: newPosition,
        });
      }
    };

    document.addEventListener("sequencer:playing", trackChange);
    document.addEventListener("sequencer:position", positionChange);

    return () => {
      document.removeEventListener("sequencer:playing", trackChange);
      document.removeEventListener("sequencer:position", positionChange);
    };
  }, [currentTrack.url, currentTrack.position, setTrack, trackLoaded]);

  return <div id={id} style={{ width, height }} />;
}
